import {EnvironmentInterface} from '../app/_interfaces/environment.interface';

export const environment: EnvironmentInterface = {
  production: true,
  appVersion: 'NL 0.06.01',
  language: 'nl',
  dbLanguage: 'nl',
  apiConfig: {
    requestVerificationCode: 'https://requestverificationcode-lsk2l64wbq-ew.a.run.app',
    verifyCodeForLocation: 'https://verifycodeforlocation-lsk2l64wbq-ew.a.run.app',
    requestResetPasswordEmail: 'https://requestresetpasswordemail-lsk2l64wbq-ew.a.run.app',
    getLocationPresenceForDate: 'https://getlocationpresencefordate-lsk2l64wbq-ew.a.run.app',
    getLocationSchedule: 'https://getlocationschedule-lsk2l64wbq-ew.a.run.app',
    locationClockIn: 'https://locationclockin-lsk2l64wbq-ew.a.run.app',
    locationClockOut: 'https://locationclockout-lsk2l64wbq-ew.a.run.app',
  },
  // apiConfig: {
  //   requestVerificationCode: 'http://127.0.0.1:5001/prod-ehr-nl/europe-west1/requestVerificationCode',
  //   verifyCodeForLocation: 'http://127.0.0.1:5001/prod-ehr-nl/europe-west1/verifyCodeForLocation',
  //   requestResetPasswordEmail: 'http://127.0.0.1:5001/prod-ehr-nl/europe-west1/requestResetPasswordEmail',
  //   getLocationPresenceForDate: 'http://127.0.0.1:5001/prod-ehr-nl/europe-west1/getLocationPresenceForDate',
  //   getLocationSchedule: 'http://127.0.0.1:5001/prod-ehr-nl/europe-west1/getLocationSchedule',
  //   locationClockIn: 'http://127.0.0.1:5001/prod-ehr-nl/europe-west1/locationClockIn',
  //   locationClockOut: 'http://127.0.0.1:5001/prod-ehr-nl/europe-west1/locationClockOut',
  // },
  firebaseConfig: {
    apiKey: 'AIzaSyBpkLJjaQcbGtj-vqy8ZMod2O9q7mKRoEk',
    authDomain: "prod-ehr-nl.firebaseapp.com",
    projectId: 'prod-ehr-nl',
    storageBucket: "prod-ehr-nl.firebasestorage.app",
    messagingSenderId: "681953294611",
    appId: '1:681953294611:web:c1c3f580a91f3ea6b682e6',
    measurementId: 'G-MXY102SHDW'
  }
}
